import axios from 'axios'
import config from '../config'
import { getUserToken } from "../utils"

const savePatientApi = async (params) => {
    const response = await axios({
        url: `${config.api.base_url}patient`,
        method: params.mode === "edit" ? "put" : "post",
        data: params,
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${getUserToken()}`
        }
    })

    return response

}

export default savePatientApi